export default function MyJobsSkeleton() {
  return (
    <div className="w-full pl-0 sm:pl-4 pt-8 pb-6">
      <div className="w-full md:w-auto flex flex-col items-start">
        <h2 className="text-title-medium pb-1">PGA Job Board - All Jobs</h2>
        <p className="text-body-medium">View and manage all jobs posted for facilities on the PGA job board</p>
      </div>
      <div className="mt-4 h-12 bg-gray-200 rounded animate-pulse" />
    </div>
  );
}
